<div id="skills-content">

  <div class="content-description">
    <h2>SKILLS</h2>
    <p>In this section my core skills as a software developer</p>
  </div>

  <div class="skills-tech">
    <div class="skills-items" *ngFor="let skill of skills">
      <div class="skill-name">
        {{skill.name}}
      </div>
      <div class="skill-bar-background">
        <div class="skill-bar" [ngStyle]="{'width': skill.level, 'background': getColor(skill.color1, skill.color2)}">
          &nbsp;
        </div>
      </div>
    </div>
    <div class="tech-text">
      <h3>OTHER SKILLS</h3>
      <p>React Native, C++, Matlab, Redux, React Query, Robot Framework, Jest, Electron</p>
      <p>HgMercurial, Git, Jira</p>
    </div>
  </div>

</div>
